import React, { useState, useEffect } from "react";
import "./index.css";

const UserWayAccessibilityMenu = ({ width, height, showAngelAiHeader }) => {
  const [color, setColor] = useState(window.innerWidth > 992? "black" : "white");
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1024);

  useEffect(() => {
    const updateScreenSize = () => {
      const desktopView = window.innerWidth > 992;
      setIsDesktop(desktopView);
      setColor(desktopView ? "black" : "white"); // Update color based on view
    };

    window.addEventListener("resize", updateScreenSize);
    return () => window.removeEventListener("resize", updateScreenSize);
  }, []);

  useEffect(() => {
    if (!isDesktop) return; // Only run effect on desktop

    const handleScroll = () => {
      setColor(window.scrollY > 10 ? "white" : "black");
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isDesktop]); // Re-run effect when `isDesktop` changes

  const accessibilityIcon = `${process.env.REACT_APP_CDN}swmc/images/accessibility-icon-wheel_left_${color}.svg`;

  return (
    <div className={`userWayContainer ${showAngelAiHeader ? "userWayContainerAngelAi" : ""}`}>
      <button
        id="UserWayAccessibilityMenu"
        title="Accessibility Menu"
        className="userWayBackGroundBody"
        onClick={() => {
          if (window.UserWay && typeof window.UserWay.widgetToggle === "function") {
            window.UserWay.widgetToggle();
          }
        }}
      >
        <img src={accessibilityIcon} alt="Open the Accessibility Menu" style={{ width, height }} />
      </button>
    </div>
  );
};

export default UserWayAccessibilityMenu;
